import React from "react";
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import { ConfigProvider } from "antd";
import MainLayout from "./components/MainLayout";
import Dashboard from "./components/Dashboard";
import Authentication from "./components/Authentication";
import Authorization from "./components/Authorization";
import PageNotFound from "./components/PageNotFound";
import Login from "./components/Login";
import MovingTextTable from "./components/Admin/Moving Text/MovingTextTable";
import ExternalLinksTable from "./components/Admin/External Links/ExternalLinksTable";
import GrampachayatiTable from "./components/Admin/Grampanchayati Home/GrampachayatiTable";
import ItarMahitiTable from "./components/Admin/Itar Mahiti/ItarMahitiTable";
import SuchanaTable from "./components/Admin/Suchana/SuchanaTable";
import Homepage from "./components/website/Homepage";
import ComingSoon from "./components/website/ComingSoon";
import HomeComponent from "./components/website/HomeComponent";
import VideoLinksTable from "./components/Admin/Video/VideoLinksTable";
import ImageTable from "./components/Admin/Images/ImageTable.js";
import Officers from "./components/website/Officers.js";
import PhotoGallary from "./components/website/PhotoGallary.js";
import VideoGallary from "./components/website/VideoGallary.js";
import NoticeDetails from "./components/website/NoticeDetails.js";
import GrievanceTable from "./components/Admin/Grievance/GrievanceTable.js";
import AdhikariTable from "./components/Admin/Adhikari/AdhikariTable.js";
import PadadhikariTable from "./components/Admin/Padhadhikari/PadadhikariTable.js";
import AboutUs from "./components/website/AboutUs.js";
import ContactUs from "./components/website/ContactUs.js";
import Grievance from "./components/website/Grievance.js";
import Initiations from "./components/website/Initiations.js";
import PublicGrievance from "./components/website/PublicGrievance.js";
import RightToInformation from "./components/website/RightToInformation.js";
import Contact from "./components/website/Contact.js";
import Manyavar from "./components/website/Manyavar.js";
import Padhadhikari from "./components/website/Padhadhikari.js";
import LoksevaAdhiniyam from "./components/website/LoksevaAdhiniyam.js";
import Sanad from "./components/website/Sanad.js";
import VibhagDetails from "./components/website/VibhagDetails.js";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="" element={<Homepage />}>
        <Route path="/" element={<HomeComponent />} />
        <Route path="/officers" element={<Officers />} />
        <Route path="/manyavar" element={<Manyavar />} />
        <Route path="/padadhikari" element={<Padhadhikari />} />
        <Route path="/departments" element={<ComingSoon />} />
        <Route path="/advertising" element={<ComingSoon />} />
        <Route path="/photo-gallery" element={<PhotoGallary />} />
        <Route path="/video-gallery" element={<VideoGallary />} />
        <Route path="/notice" element={<NoticeDetails />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/grievance" element={<Grievance />} />
        <Route path="/public-grievance" element={<PublicGrievance />} />
        <Route path="/rightToInfomtion" element={<RightToInformation />} />
        <Route path="/lokseva" element={<LoksevaAdhiniyam />} />
        <Route path="/sanad" element={<Sanad />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/vibhag/:vibhagId" element={<VibhagDetails />} />
        {/* <Route path="/contact" element={<ContactUs />} /> */}
        <Route path="/nivida" element={<ComingSoon />} />
        <Route path="/initiations" element={<Initiations />} />
      </Route>
      <Route path="/login" element={<Login />} />

      <Route element={<Authentication />}>
        <Route path="portal" element={<MainLayout />}>
          <Route path="/portal/dashboard" element={<Dashboard />} />
          <Route element={<Authorization allowedRoles={["admin"]} />}>
            <Route
              path="/portal/admin/moving-text"
              element={<MovingTextTable />}
            />
            <Route
              path="/portal/admin/external-link"
              element={<ExternalLinksTable />}
            />
            <Route
              path="/portal/admin/grampanchayati-text"
              element={<GrampachayatiTable />}
            />
            <Route
              path="/portal/admin/important-forms"
              element={<ItarMahitiTable />}
            />
            <Route path="/portal/admin/suchana" element={<SuchanaTable />} />
            <Route path="/portal/admin/videos" element={<VideoLinksTable />} />
            <Route path="/portal/admin/images" element={<ImageTable />} />
            <Route
              path="/portal/admin/grievance"
              element={<GrievanceTable />}
            />
            <Route
              path="/portal/admin/adhikari"
              element={<AdhikariTable />}
            />
            <Route
              path="/portal/admin/padadhikari"
              element={<PadadhikariTable />}
            />
            {/* allowedRoles is array */}
            {/* all admin only routes here */}
          </Route>
        </Route>

        <Route path="unauthorized" element={<>Unauthorized</>} />
      </Route>
      <Route path="*" element={<PageNotFound />} />
    </>
  )
);

function App() {
  return (
    <ConfigProvider
      theme={{
        components: {
          Collapse: {
            headerBg: "rgb(20, 168, 0)",
            colorTextHeading: "rgb(255, 255, 255)",
          },
        },
        token: {
          algorithm: "compactAlgorithm",
          // Seed Token
          colorPrimary: "#1677ff",
          borderRadius: 11,
          fontFamily: "Arial",
          colorTextBase: "#455560",
        },
      }}
    >
      <RouterProvider router={router} />
    </ConfigProvider>
  );
}

export default App;
